import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { assistantsApi } from '@shared/api/assistants'
import type { CreateAssistantRequest } from '@shared/types/api'

// Получить список ассистентов организации
export function useAssistants(orgId: string) {
  return useQuery({
    queryKey: ['assistants', orgId],
    queryFn: () => assistantsApi.getByOrganizationId(orgId),
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
  })
}

// Получить одного ассистента
export function useAssistant(assistantId: string) {
  return useQuery({
    queryKey: ['assistant', assistantId],
    queryFn: () => assistantsApi.getById(assistantId),
    enabled: !!assistantId,
  })
}

// Создать ассистента
export function useCreateAssistant() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateAssistantRequest) => assistantsApi.create(data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['assistants', variables.organization_id] })
    },
  })
}

// Активировать/деактивировать ассистента
export function useToggleAssistant() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, activate }: { id: string; activate: boolean }) =>
      activate ? assistantsApi.activate(id) : assistantsApi.deactivate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assistants'] })
    },
  })
}

// Удалить ассистента
export function useDeleteAssistant() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (assistantId: string) => assistantsApi.delete(assistantId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assistants'] })
    },
  })
}
